import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { CoreMsgTypes, LiquidityStatistics } from '@tassat/fred-definitions';

export type LiquidityFacilityStatsState = Record<string, Record<string, LiquidityStatistics>>;

const initialState: LiquidityFacilityStatsState = {};

const initialLoad = createAction<{ liquidityFacilityStats: LiquidityFacilityStatsState }>('InitialLoad');
const liquidityStatisticsRecord = createAction<LiquidityStatistics>(CoreMsgTypes.LiquidityStatistics);

const liquidityStatisticsSlice = createSlice({
    name: 'liquidityStatistics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoad, (_state, action) => {
                return action.payload.liquidityFacilityStats;
            })
            .addCase(liquidityStatisticsRecord, (state, action) => {
                if (!state[action.payload.FirmId]) {
                    state[action.payload.FirmId] = {};
                }
                state[action.payload.FirmId][action.payload.AssetId] = action.payload;
            })
            .addDefaultCase(state => state);
    }
});

export default liquidityStatisticsSlice.reducer;